import React, { useEffect, useState } from 'react';
import { common } from '@kurtosys/ksys-app-template';

import { ITranslationContextValue } from '../../Translate/models/ITranslationContextValue.js';
import { IPagingValues } from '../models/IPagingValues.js';
import StyledPagingResultsStatus from '../styledComponents/PagingResultsStatus.js';

interface PagingResultsStatusProps {
	pagingLabelFormat?: string;
	pagingValues: IPagingValues;
	translationContext: ITranslationContextValue;
}

export const PagingResultsStatus: React.FC<PagingResultsStatusProps> = ({
	pagingLabelFormat = '{firstItem} - {lastItem} / {totalRows}',
	pagingValues: initialPagingValues,
	translationContext,
}) => {
	const [pagingValues, setPagingValues] = useState(initialPagingValues);
	const [label, setLabel] = useState(getLabel(pagingLabelFormat, pagingValues));

	function getLabel(text: string, values: any) {
		return translationContext
			? translationContext.translate(text, values)
			: common.commonUtils.replacePlaceholders({ values, text });
	}

	useEffect(() => {
		setPagingValues(initialPagingValues);
		setLabel(getLabel(pagingLabelFormat, initialPagingValues));
	}, [initialPagingValues, pagingLabelFormat]);

	return <StyledPagingResultsStatus aria-hidden="true">{label}</StyledPagingResultsStatus>;
};
